






























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';

import { errorHandling } from '@/helpers/errorHandling';
import { InputEventHelper } from '@/helpers/input-event';
import UiAutocompleClientsSubsidiaries from '../UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '../UI/list-messages.vue';
import Unit from '../../views/client-units/screens/index.vue';
import ClientUnitModel from '../../models/client-unit-model';
import IClientUnit from '../../interfaces/clientUnit';
import * as service from '../../services/bag-models';
import { IdNomeDTO } from '../../interfaces/base-dto';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { ModeloParmDTO, ModeloDTO, CompartimentoDTO, CompartimentoParmDTO } from '../../interfaces/bag-models';

@Component({
  components: {
    PermissionAuth,
    UiSelectClients,
    UiAutocompleClientsSubsidiaries,
    ListMessages,
  },
  directives: {
    currency: CurrencyDirective,
  },
})
export default class BagModelForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: Number;
  @Prop()
  public open: boolean;

  private loading: boolean = false;
  private error: boolean = false;

  private produtos: IdNomeDTO[] = [];
  private produtosSelec: IdNomeDTO[] = [];

  public form: any = {
    valid: false,
    rules: {
      codigo: [(v) => !!v || 'Informe o Código do Modelo'],
      nome: [(v) => !!v || 'Informe o Nome do Modelo'],
      ativo: [(v) => v != null || 'Informe o Status'],
    },
  };
  private modelo: ModeloDTO = new ModeloDTO();

  maskCapacidade = {
    currency: { prefix: '', suffix: ' mL' },
    locale: 'pt-BR',
    precision: { min: 0, max: 2 },
  };

  private capacTotal = '1000 mL';

  private calcularCapacTotal() {
    let cap = 0;
    this.modelo.compartimentos
      .filter((f) => f.capacidadeMlFormat)
      .forEach((c) => {
        cap += this.getValorSemMask(String(c.capacidadeMlFormat), this.maskCapacidade);
      });
    this.capacTotal = this.getQuantProdFormat(cap);
  }

  private getQuantProdFormat(quant: Number): string {
    if (!quant) {
      return null;
    }
    return String(quant).replace('.', ',') + ' mL';
  }

  getValorSemMask(valor: string, mask) {
    return parseCurrency(valor, mask);
  }

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        if (this.id) {
          this.buscarModelo();
        } else {
          this.prepararProdutosSelec();
        }
      }
    }, 200);
  }

  private mounted() {
    this.prepararProdutos();
  }

  private prepararProdutos(): void {
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getBagModelsProducts().subscribe(
        (result) => {
          this.loading = false;
          this.produtos = result;
          this.prepararProdutosSelec();
          if (this.id) {
            this.buscarModelo();
          }
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private getProdutosItem(itemSelec): any[] {
    return this.produtos.filter(
      (p) =>
        (itemSelec && p.id == itemSelec.id) ||
        !this.produtosSelec.filter((sp) => sp != null && sp.id == p.id).length,
    );
  }

  private buscarModelo() {
    if (!this.id && this.produtos.length) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getBagModelsById(this.id).subscribe(
        (result) => {
          this.modelo = result;
          this.loading = false;
          this.error = false;
          this.prepararProdutosSelec();
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private prepararProdutosSelec() {
    this.produtosSelec = new Array();
    this.modelo.compartimentos.forEach((c) => {
      c.idsProdutos.forEach((p) => {
        if (!this.produtosSelec.find((f) => f && Number(f.id) == p)) {
          this.produtosSelec.push(this.produtos.find((f) => Number(f.id) == p));
        }
      });
    });
    this.ajustarProdutos();
    this.ajustarCompartimentos();
  }

  private onChangeProduto() {
    setTimeout(() => {
      this.ajustarProdutos();
    }, 300);
  }

  private ajustarProdutos() {
    this.produtosSelec = this.produtosSelec.filter((p) => p != null && p.id != null);
    if (!this.produtosSelec.length || this.produtosSelec[this.produtosSelec.length - 1] != null) {
      this.produtosSelec.push(null);
    }
    while (this.produtosSelec.length < 4) {
      this.produtosSelec.push(null);
    }
  }

  private onChangeCapacidade() {
    setTimeout(() => {
      this.ajustarCompartimentos();
    }, 300);
  }

  ajustarCompartimentos(): boolean {
    let addComp = false;
    let compartimentos = this.modelo.compartimentos;
    for (let i = compartimentos.length - 1; i >= 0; i--) {
      if (!compartimentos[i].capacidadeMlFormat) {
        compartimentos.splice(i, 1);
      } else {
        break;
      }
    }
    let ultCompart = compartimentos[compartimentos.length - 1];
    if (!ultCompart || ultCompart.capacidadeMlFormat) {
      this.addCompartimento();
      addComp = true;
    }
    while (this.modelo.compartimentos.length < 2) {
      this.addCompartimento();
      addComp = true;
    }
    this.calcularCapacTotal();
    return addComp;
  }

  addCompartimento() {
    let compartimentos = this.modelo.compartimentos;
    let ultCompart = compartimentos[compartimentos.length - 1];
    let newletra = ultCompart ? String.fromCharCode(ultCompart.letra.trim().charCodeAt(0) + 1) : 'A';
    let newComp = new CompartimentoDTO();
    newComp.letra = newletra;
    this.modelo.compartimentos.push(newComp);
  }

  private setFocus(refName) {
    setTimeout(() => {
      let elem: any = this.$refs[refName];
      if (elem && elem.length) {
        elem[0].focus();
      }
    }, 100);
  }

  private getRefInput(linha, coluna) {
    return 'input-' + linha + '-' + coluna;
  }

  private timeoutMatrizKeyDown: any;
  private matrizKeyDown(event, linha, coluna) {
    if (this.timeoutMatrizKeyDown) {
      clearTimeout(this.timeoutMatrizKeyDown);
    }

    this.timeoutMatrizKeyDown = setTimeout(() => {
      this.matrizKeyDownExec(event, linha, coluna);
    }, 30);
  }

  private matrizKeyDownExec(event, linha, coluna) {
    if (!event) {
      return;
    }
    if (InputEventHelper.isSetaEsquerda(event)) {
      coluna--;
    } else if (InputEventHelper.isSetaDireita(event) || (InputEventHelper.isTab(event) && !event.shiftKey)) {
      // Saindo do campo com seta para direita ou com Tab.
      // Caso precise criar o novo compartimento, criará e tera foco no novo campo a direita:
      if (this.ajustarCompartimentos()) {
        event.preventDefault();
      }
      coluna++;
    } else if (InputEventHelper.isSetaBaixo(event)) {
      linha++;
    } else if (InputEventHelper.isSetaCima(event)) {
      linha--;
    } else {
      return;
    }
    this.setFocus(this.getRefInput(linha, coluna));
  }

  public resetForm(): void {
    this.$refs.form.resetValidation();
    this.modelo = new ModeloDTO();
    this.produtosSelec = [];
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');

    let parm: ModeloParmDTO = new ModeloParmDTO();
    parm.id = this.modelo.id;
    parm.codigo = this.modelo.codigo;
    parm.nome = this.modelo.nome;
    parm.ativo = this.modelo.ativo;
    parm.compartimentos = new Array();
    this.modelo.compartimentos.forEach((c) => {
      if (!c.capacidadeMlFormat) {
        return;
      }
      let comp = new CompartimentoParmDTO();
      comp.idsProdutos = [];
      comp.letra = c.letra;
      comp.capacidadeMl = this.getValorSemMask(String(c.capacidadeMlFormat), this.maskCapacidade);
      c.idsProdutos.forEach((idProd) => {
        if (this.produtosSelec.find((f) => f && f.id == String(idProd))) {
          comp.idsProdutos.push(idProd);
        }
      });
      parm.compartimentos.push(comp);
    });

    this.addSubsc(
      service.saveBagModel(parm).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.toast.show(error.data.message, 'error');
        },
      ),
    );
  }

  public closeForm(): void {
    const closeAction = () => {
      this.resetForm();
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  selecionarTodosProdutos() {
    this.produtos.forEach(p => {
      if(!this.produtosSelec.find(ps => ps != null && ps.id == p.id)) {
        this.produtosSelec.push(p);
      }
    });
    this.produtos.sort((p1,p2) => { 
      if(p1 == null || p2 == null) {
        return 0;
      }  
      return String(this.extrairNomeProduto(p1)).localeCompare(this.extrairNomeProduto(p2));
    });
    this.ajustarCompartimentos();
    this.ajustarProdutos();
  }

  extrairNomeProduto(p) {
    return p.nome.substring(p.nome.indexOf("- "), p.nome.length).trim();
  }

  removerTodosProdutos() {
    this.produtosSelec.splice(0,this.produtosSelec.length);
    this.ajustarCompartimentos();
    this.ajustarProdutos();
  }
}
